// Mirror the native selection; never infer eligibility, availability or price.
(() => {
  const disposers = new Map();
  const initialize = () => {
    document.querySelectorAll('[data-product-details]:not([data-specs-initialized])').forEach(page => {
      page.dataset.specsInitialized = 'true';
      const select = page.querySelector('[data-variant-selector]');
      const openInformation = id => {
        const target = document.getElementById(id);
        if (target && page.contains(target)) { const panel = target.querySelector('.v25-information-panel'); if (panel) panel.open = true; }
      };
      page.querySelectorAll('.p26-content-nav a[href^="#"]').forEach(link => link.addEventListener('click', () => openInformation(link.getAttribute('href').slice(1))));
      if (location.hash) openInformation(location.hash.slice(1));
      const choices = [...page.querySelectorAll('[data-pack-choice]')];
      if (select && choices.length) {
        page.querySelector('[data-pack-choices]').hidden = false;
        select.hidden = true;
        page.querySelector(`label[for="${select.id}"]`).hidden = true;
        choices.forEach(choice => choice.addEventListener('change', () => {
          if (!choice.checked) return;
          select.value = choice.value;
          select.dispatchEvent(new Event('change', {bubbles: true}));
        }));
      }
      const primary = page.querySelector('.product-main [data-product-inquiry]');
      const mobileBar = page.querySelector('[data-mobile-inquiry]');
      const mobileLink = page.querySelector('[data-mobile-inquiry-link]');
      let refreshMobile = () => {};
      if (primary && mobileBar && mobileLink) {
        const mobile = matchMedia('(max-width: 760px)');
        const footer = document.querySelector('.site-footer');
        let frame = 0;
        const update = () => {
          frame = 0;
          if (!mobile.matches) { mobileBar.hidden = true; return; }
          const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 126;
          const footerRect = footer?.getBoundingClientRect();
          const footerVisible = footerRect && footerRect.top < innerHeight && footerRect.bottom > 0;
          mobileBar.hidden = !(primary.getBoundingClientRect().bottom <= headerHeight && !footerVisible);
        };
        // Anchor jumps can move an off-screen action from below to above the viewport
        // without crossing an IntersectionObserver threshold.
        refreshMobile = () => { if (!frame) frame = requestAnimationFrame(update); };
        window.addEventListener('scroll', refreshMobile, {passive: true});
        window.addEventListener('resize', refreshMobile, {passive: true});
        window.addEventListener('load', refreshMobile, {once: true});
        mobile.addEventListener('change', refreshMobile);
        refreshMobile();
        disposers.set(page, () => {
          cancelAnimationFrame(frame);
          window.removeEventListener('scroll', refreshMobile);
          window.removeEventListener('resize', refreshMobile);
          window.removeEventListener('load', refreshMobile);
          mobile.removeEventListener('change', refreshMobile);
        });
      }
      if (!select) return;
      const reflect = () => {
        const selected = select.selectedOptions[0];
        if (!selected) return;
        choices.forEach(choice => { choice.checked = choice.value === selected.value; });
        const pack = page.querySelector('[data-selected-pack-detail]');
        const sku = page.querySelector('[data-selected-sku-detail]');
        const imageNote = page.querySelector('[data-image-note]');
        if (pack) pack.textContent = selected.dataset.title || '';
        if (sku) sku.textContent = selected.dataset.sku || '';
        if (imageNote) imageNote.textContent = selected.dataset.image ? 'Selected pack photo.' : 'Product packaging. Check the selected pack specification.';
        if (primary && mobileLink) mobileLink.href = primary.href;
        const mobilePack = page.querySelector('[data-mobile-pack]');
        if (mobilePack) mobilePack.textContent = primary?.dataset.defaultVariant === 'true' ? selected.dataset.sku || '' : selected.dataset.title || '';
        refreshMobile();
      };
      // Run after the existing variant handler, which also writes the photo caption.
      select.addEventListener('change', () => queueMicrotask(reflect));
      reflect();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    for (const [page, dispose] of disposers) if (event.target.contains(page)) { dispose(); disposers.delete(page); }
  });
})();
